import { Tooltip } from '@components/ui/Tooltips'

interface TooLongTextProps {
  withPortal?: boolean
  value: string
  maxLength?: number
}

// maxLength must be greater than 7
export default function TooLongText({ withPortal = false, value, maxLength = 18 }: TooLongTextProps) {
  const valueLength = value.length

  if (valueLength > maxLength) {
    const shortenedValue = `${value.substring(0, maxLength - 7)}...${value.substring(valueLength - 4)}`
    return (
      <Tooltip title={value} withPortal={withPortal}>
        <span>{shortenedValue}</span>
      </Tooltip>
    )
  }

  return <>{value}</>
}
